import { render } from "./InfoBox.vue?vue&type=template&id=332d704a&scoped=true"
import script from "./InfoBox.vue?vue&type=script&lang=js"
export * from "./InfoBox.vue?vue&type=script&lang=js"

import "./InfoBox.vue?vue&type=style&index=0&id=332d704a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332d704a"]])

export default __exports__